import { c as _c } from "react/compiler-runtime";
import type { DocumentRequirementConfig } from '@onefootprint/types';
import { DocumentRequestKind } from '@onefootprint/types';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';
import getCustomDocInfo from '../../../utils/get-custom-doc-info';
const useTitleAndDescription = config => {
  const $ = _c(25);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.non-id-doc.pages.document-prompt"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  const {
    kind: documentKind
  } = config;
  if (documentKind === DocumentRequestKind.Identity) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        title: "",
        description: ""
      };
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let docKindToTitle;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== config || $[3] !== t) {
    const {
      documentName,
      documentDescription
    } = getCustomDocInfo(config);
    docKindToTitle = {
      [DocumentRequestKind.ProofOfAddress]: t(_temp),
      [DocumentRequestKind.ProofOfSsn]: t(_temp2),
      [DocumentRequestKind.Custom]: t(_temp3, {
        documentName: upperFirst(documentName)
      })
    };
    t1 = DocumentRequestKind.ProofOfAddress;
    if ($[11] !== t) {
      t2 = t(_temp4);
      $[11] = t;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    t3 = DocumentRequestKind.ProofOfSsn;
    if ($[13] !== t) {
      t4 = t(_temp5);
      $[13] = t;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t5 = DocumentRequestKind.Custom;
    t6 = t(_temp6, {
      documentDescription
    });
    $[2] = config;
    $[3] = t;
    $[4] = docKindToTitle;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    docKindToTitle = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = {
      [t1]: t2,
      [t3]: t4,
      [t5]: t6
    };
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const docKindToDescription = t7;
  const t8 = docKindToTitle[documentKind];
  const t9 = docKindToDescription[documentKind];
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = {
      title: t8,
      description: t9
    };
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default useTitleAndDescription;
function _temp($) {
  return $["proof-of-address"].title;
}
function _temp2($_0) {
  return $_0["proof-of-ssn"].title;
}
function _temp3($_1) {
  return $_1.custom.title;
}
function _temp4($_2) {
  return $_2["proof-of-address"].description;
}
function _temp5($_3) {
  return $_3["proof-of-ssn"].description;
}
function _temp6($_4) {
  return $_4.custom.description;
}